import { RootState } from '@AppState/redux-store'
import { AuthScopes, FeatureFlag } from '@Generated/back-office-client/src'
import React from 'react'
import { useSelector } from 'react-redux'

export const WithPermissions = ({
  requiredPermissions,
  requiredFeature,
  children,
}: {
  requiredPermissions?: AuthScopes | AuthScopes[]
  requiredFeature?: FeatureFlag
  children: React.ReactNode
}) => {
  const { currentUser } = useSelector((state: RootState) => state.users)

  if (requiredFeature && !currentUser?.enabledFeatures?.includes(requiredFeature)) {
    return null
  }

  if (requiredPermissions) {
    const perms =
      typeof requiredPermissions === 'string' ? [requiredPermissions] : requiredPermissions
    if (!perms.some((p) => currentUser?.scopes.includes(p))) {
      return null
    }
  }

  return <>{children}</>
}
